(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["UV-Testamonial-Slider"] && !Shopify.designMode) return;
  try {
    
  function initUVSlider() {
    // Check if Swiper exists
    if (typeof Swiper === 'undefined') return;

    var sliders = document.querySelectorAll('.uv-swiper');

    sliders.forEach(function(slider) {
      // Read specific settings for this instance
      var desktopSlides = parseFloat(slider.getAttribute('data-desktop-slides')) || 3;
      
      // Look for navigation arrows relative to this slider section
      var section = slider.closest('.uv-testimonial-sec');
      var nextEl = section ? section.querySelector('.uv-next') : null;
      var prevEl = section ? section.querySelector('.uv-prev') : null;

      new Swiper(slider, {
        slidesPerView: 1.1,
        spaceBetween: 15,
        centeredSlides: false,
        loop: false,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: desktopSlides,
            spaceBetween: 30,
          }
        }
      });
    });
  }

  // Safe Loading Logic
  function waitForSwiperUV(trigger) {
    var interval = setInterval(function () {
      if (typeof Swiper !== 'undefined') {
        clearInterval(interval);
        trigger();
      }
    }, 200);
    setTimeout(function () { clearInterval(interval); }, 10000);
  }

  document.addEventListener("DOMContentLoaded", function() {
    waitForSwiperUV(initUVSlider);
  });
  
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      waitForSwiperUV(initUVSlider);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordian_with_video"] && !Shopify.designMode) return;
  try {
    
  
// document.querySelectorAll('.accordian-container .question').forEach(function (question) {
//     question.addEventListener('click', function () {
//         // Remove 'active' class from all 'question' elements
//         document.querySelectorAll('.accordian-container .active').forEach(function (activeQuestion) {
//             activeQuestion.classList.remove('active');
//         });
//         this.parentNode.classList.add('active');
//         var id = this.parentNode.getAttribute('data-id');       
//         document.querySelectorAll('.accordian-image img').forEach(function (activeImage) {
//             activeImage.classList.remove('active');
//         });
//         var targetImages = document.querySelectorAll('.accordian-image .' + id);
//         targetImages.forEach(function (targetImage) {
//             targetImage.classList.add('active');          
//         });
       
//     });
// });

document.querySelectorAll('.accordian-container .question').forEach(function (question) {
    question.addEventListener('click', function () {
        var isActive = this.parentNode.classList.contains('active');

        // Remove 'active' class from all 'question' elements
        document.querySelectorAll('.accordian-container .active').forEach(function (activeQuestion) {
            activeQuestion.classList.remove('active');
        });

        // Toggle the 'active' class for the clicked question
        if (!isActive) {
            this.parentNode.classList.add('active');
        }
       
    });
});


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logoSlider"] && !Shopify.designMode) return;
  try {
    
    function waitForjQuery(trigger) {
      var interval = setInterval(function() {
        if (typeof window.jQuery != "undefined") {
        clearInterval(interval);
        trigger(window.jQuery);
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 15000);
      }

     function waitForSwiper(trigger) {
      var interval = setInterval(function() {
        if (typeof window.Swiper != 'undefined') {
        clearInterval(interval);
        trigger();
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 15000);
      }

   function waitForElement(selector, trigger) {
      var interval = setInterval(function() {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function() {
        clearInterval(interval);
      }, 15000);
    }

    function init() {
        waitForSwiper(function(){
          const swiper = new Swiper('.gem_logoSlider-mobile .swiper ', {
            pagination: false,
            slidesPerView: 1,
              speed:850,
            loop: true,
              autoplay: {
                delay: 5000,
              },
             breakpoints: {
                   
                    0: {
                        slidesPerView: 2.5,
                      speed: 19000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: true
                },
                    }
                },

            });
        })

    } 

	  waitForjQuery(function(){
		$ = window.jQuery;	 
      waitForElement(".gem_logoSlider-mobile .swiper", init, 50, 5000);

      })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop_by_category_slider"] && !Shopify.designMode) return;
  try {
    
document.querySelector(".slider-icons .swiper-button-prev").addEventListener("click", function(){
    document.querySelector(".category_collection_product swiper-slider .swiper-button-prev").click();
})

document.querySelector(".slider-icons .swiper-button-next").addEventListener("click", function(){
    document.querySelector(".category_collection_product swiper-slider .swiper-button-next").click();
  
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
     function waitForSwiper(trigger) {
      var interval = setInterval(function () {
        if (typeof Swiper != 'undefined') {
          clearInterval(interval);
          trigger();
        }
      })
      setTimeout(function () {
        clearInterval(interval);
      }, 15000)
    }
  
    function testimonialSlider() {
      var swiper = new Swiper('.silky-swiper', {
         
         spaceBetween:20,
         navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          breakpoints: {
          769: {
            slidesPerView: 2.5,

          },
          0: {
             centeredSlides: true,
            loop:true,
            slidesPerView: 1.2,
            spaceBetween:10,
            
          },

        },

      });

    }

   waitForSwiper(function () {
        testimonialSlider();
      })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-may-also-like"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
